import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { FullscreenService } from 'src/app/shared/services/fullscreen.service';
import { FilterComponent } from './filter/filter.component';
import { GlobeComponent } from './globe/globe.component';
import { CacheService } from 'src/app/shared/services/cache.service';
import { IMarisData } from 'src/app/shared/interfaces/maris-data.interface';
import { LoadingService } from 'src/app/shared/services/loading.service';
import { GlobeService } from 'src/app/shared/services/globe.service';

@Component({
    selector: 'app-explore-mapbox',
    templateUrl: './explore-mapbox.component.html',
    styleUrls: ['./explore-mapbox.component.scss'],
})
export class ExploreMapBoxComponent implements OnInit, AfterViewInit {
    @ViewChild('filter', { static: false }) filter: FilterComponent;
    @ViewChild(GlobeComponent, { static: true }) globe: GlobeComponent;

    marisData: IMarisData;

    fullscreen = false;
    showSpinner = false;
    measurementData = [];

    constructor(private cacheService: CacheService, private fullScreenService: FullscreenService, private loadingService: LoadingService, private globeService: GlobeService) {
        this.fullScreenService.getFullScreenStatus().subscribe((data) => {
            this.fullscreen = data;
        });
    }

    ngAfterViewInit(): void {
        this.cacheService.isCached().subscribe((cached) => {
            if (cached) {
                this.marisData = this.cacheService.getMarisData();
            }
        });
    }

    ngOnInit(): void {}

    onMeasurementDataLoad(event) {
        this.measurementData = event;
    }

    onSeeAreaClick($event) {
        this.filter.openedFilterControl = this.filter.seaAreaFilter;
        this.filter.applySeaAreaFilterValue($event.toString());
    }

    onShapeTypeChanged($event) {
        this.globe.shapeTypeId = $event;
        if (this.globe.styleInitiated) {
            this.globe.boundaryVisibilityChange(false);
        }
    }

    onGlobeLoadingComplete($event) {
        this.showSpinner = false;
        this.loadingService.setLoadingStatus(false);
    }

    onFilterChanged($event) {
        this.globeService.sendfilterValue($event);
    }

    onSummaryStatisticsChange($event) {
        this.globe.onSummaryStatisticsChanged($event);
    }
}
